(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["classrooms/includes/components/_bulk_qr_distribute.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"distribute\">\n    <div class=\"comet-modal__content\">\n        <div class=\"distribute__header\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "student")) {
output += "\n                <h3>";
output += runtime.suppressValue((lineno = 4, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Select Layout and Download QR Code"])), env.opts.autoescape);
output += "</h3>\n            ";
;
}
else {
output += "\n                <h3>";
output += runtime.suppressValue((lineno = 6, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Select Layout and Download QR Codes"])), env.opts.autoescape);
output += "</h3>\n            ";
;
}
output += "\n        </div>\n        <div class=\"distribute__content\">\n            <p class=\"comet-long-form-text comet-long-form-text--instruction\">\n                ";
output += runtime.suppressValue((lineno = 11, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Select a layout option from one of the standardized templates below, and then click the Download QR Codes button to download a .zip file containing all student sign-in QR codes."])), env.opts.autoescape);
output += "\n            </p>\n\n            <p class=\"comet-long-form-text comet-long-form-text--instruction\">\n                <strong>";
output += runtime.suppressValue((lineno = 15, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["PLEASE NOTE: For security purposes, Discovery Education does not store a copy of your QR Codes on our servers. You must download them before leaving the page, or all QR data will be lost."])), env.opts.autoescape);
output += "</strong>\n            </p>\n\n            <div class=\"layout-selection\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "countryCode") == "GB") {
output += "\n                    <input id=\"layout_L712125\" name=\"layout_type\" value=\"L712125\" type=\"radio\" />\n                    <label class=\"layout-selection__item\" for=\"layout_L712125\">\n                        <div class=\"layout-selection__preview\">\n                            <div class=\"layout-selection__preview--L712125\">\n                                ";
frame = frame.push();
var t_3 = (lineno = 24, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,5]));
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("r", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                                <div class=\"comet-row\">\n                                    <div class=\"comet-row__inner-flex\">\n                                        ";
frame = frame.push();
var t_7 = (lineno = 27, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,4]));
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("c", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                                            <div class=\"comet-columns comet-columns--small-3\">\n                                            </div>\n                                        ";
;
}
}
frame = frame.pop();
output += "\n                                    </div>\n                                </div>\n                                ";
;
}
}
frame = frame.pop();
output += "\n                            </div>\n                        </div>\n                        <h3>";
output += runtime.suppressValue((lineno = 36, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Avery L7121-25"])), env.opts.autoescape);
output += "</h3>\n                        <p class=\"layout-selection__description\">";
output += runtime.suppressValue((lineno = 37, colno = 69, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Print-to-the-Edge Square Labels"])), env.opts.autoescape);
output += "</p>\n                        <p>";
output += runtime.suppressValue((lineno = 38, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Label size"])), env.opts.autoescape);
output += ": 45mm x 45mm</p>\n                        <p>";
output += runtime.suppressValue((lineno = 39, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["20 labels per sheet"])), env.opts.autoescape);
output += "</p>\n                    </label>\n                ";
;
}
else {
output += "\n                    <input id=\"layout_5160\" name=\"layout_type\" value=\"5160\" type=\"radio\" />\n                    <label class=\"layout-selection__item\" for=\"layout_5160\">\n                        <div class=\"layout-selection__preview\">\n                            <div class=\"layout-selection__preview--5160\">\n                                ";
frame = frame.push();
var t_11 = (lineno = 46, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,10]));
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("r", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                                <div class=\"comet-row\">\n                                    <div class=\"comet-row__inner-flex\">\n                                        ";
frame = frame.push();
var t_15 = (lineno = 49, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,3]));
if(t_15) {t_15 = runtime.fromIterator(t_15);
var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("c", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n                                        <div class=\"comet-columns comet-columns--small-4\"></div>\n                                        ";
;
}
}
frame = frame.pop();
output += "\n                                    </div>\n                                </div>\n                                ";
;
}
}
frame = frame.pop();
output += "\n                            </div>\n                        </div>\n                        <h3>";
output += runtime.suppressValue((lineno = 57, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Avery 5160 Labels"])), env.opts.autoescape);
output += "</h3>\n                        <p class=\"description\">";
output += runtime.suppressValue((lineno = 58, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Address Labels"])), env.opts.autoescape);
output += "</p>\n                        <p>";
output += runtime.suppressValue((lineno = 59, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Label size"])), env.opts.autoescape);
output += ": 1\" x 2-5/8\"</p>\n                        <p>";
output += runtime.suppressValue((lineno = 60, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["30 labels per sheet"])), env.opts.autoescape);
output += "</p>\n                    </label>\n                    <input id=\"layout_22806\" name=\"layout_type\" value=\"22806\" type=\"radio\" />\n                    <label class=\"layout-selection__item\" for=\"layout_22806\">\n                        <div class=\"layout-selection__preview\">\n                            <div class=\"layout-selection__preview--22806\">\n                                ";
frame = frame.push();
var t_19 = (lineno = 66, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,4]));
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("r", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\n                                <div class=\"comet-row\">\n                                    <div class=\"comet-row__inner-flex\">\n                                        ";
frame = frame.push();
var t_23 = (lineno = 69, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,3]));
if(t_23) {t_23 = runtime.fromIterator(t_23);
var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("c", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "\n                                        <div class=\"comet-columns comet-columns--small-4\"></div>\n                                        ";
;
}
}
frame = frame.pop();
output += "\n                                    </div>\n                                </div>\n                                ";
;
}
}
frame = frame.pop();
output += "\n                            </div>\n                        </div>\n                        <h3>";
output += runtime.suppressValue((lineno = 77, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Avery 22806 Labels"])), env.opts.autoescape);
output += "</h3>\n                        <p class=\"description\">";
output += runtime.suppressValue((lineno = 78, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Print-to-the-Edge Square Labels"])), env.opts.autoescape);
output += "</p>\n                        <p>";
output += runtime.suppressValue((lineno = 79, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Label size"])), env.opts.autoescape);
output += ": 2\" x 2\"</p>\n                        <p>";
output += runtime.suppressValue((lineno = 80, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["12 labels per sheet"])), env.opts.autoescape);
output += "</p>\n                    </label>\n                ";
;
}
output += "\n                <input id=\"layout_single\" name=\"layout_type\" value=\"single\" type=\"radio\"  />\n                <label class=\"layout-selection__item\" for=\"layout_single\">\n                    <div class=\"layout-selection__preview\">\n                        <div class=\"layout-selection__preview--single\">\n                            <div class=\"comet-row\">\n                                <div class=\"comet-row__inner-flex\">\n                                    <div class=\"comet-columns comet-columns-small-12\">\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <h3>";
output += runtime.suppressValue((lineno = 95, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Full-size letter"])), env.opts.autoescape);
output += "</h3>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "countryCode") == "GB") {
output += "\n                        <p class=\"description\">A4 ";
output += runtime.suppressValue((lineno = 97, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Sheet Paper"])), env.opts.autoescape);
output += "</p>\n                        <p>";
output += runtime.suppressValue((lineno = 98, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Sheet size"])), env.opts.autoescape);
output += ": 210mm x 297mm </p>\n                    ";
;
}
else {
output += "\n                        <p class=\"description\">8-1/2\" x 11\" ";
output += runtime.suppressValue((lineno = 100, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Sheet Paper"])), env.opts.autoescape);
output += "</p>\n                        <p>";
output += runtime.suppressValue((lineno = 101, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Sheet size"])), env.opts.autoescape);
output += ": 8-1/2\" x 11\" </p>\n                    ";
;
}
output += "\n                    <p>";
output += runtime.suppressValue((lineno = 103, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["1 QR Code per Sheet"])), env.opts.autoescape);
output += "</p>\n                </label>\n            </div>\n        </div>\n        <div class=\"distribute__footer\">\n            <button type=\"button\" id=\"bulk_qr_distribute\" class=\"comet-button comet-button--primary comet-button--disabled\" disabled>\n                ";
if(runtime.contextOrFrameLookup(context, frame, "student")) {
output += "\n                    ";
output += runtime.suppressValue((lineno = 110, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Download QR Code"])), env.opts.autoescape);
output += "\n                ";
;
}
else {
output += "\n                    ";
output += runtime.suppressValue((lineno = 112, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Download QR Codes"])), env.opts.autoescape);
output += "\n                ";
;
}
output += "\n            </button>\n            <p class=\"comet-long-form-text\">\n                * ";
output += runtime.suppressValue((lineno = 116, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["For security purposes, please ensure school students do not share or use another student's sign-in QR Code."])), env.opts.autoescape);
output += "</p>\n        </div>\n    </div>\n</div>\n\n<div class=\"download-complete bulk-qr-form__elem--hidden\">\n    <div class=\"download-complete__header\">\n        <div class=\"qr-download-success\">\n            <svg class=\"qr-block-message__icon qr-block-message__icon--success\" aria-hidden=\"true\" focusable=\"false\">\n                <use xlink:href=\"";
output += runtime.suppressValue((lineno = 125, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#check-circle"])), env.opts.autoescape);
output += "\"></use>\n            </svg>\n        </div>\n        <h3>";
output += runtime.suppressValue((lineno = 128, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Download Complete"])), env.opts.autoescape);
output += "</h3>\n    </div>\n    <div class=\"download-complete__content\">\n        <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message"), env.opts.autoescape);
output += "</p>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "errors")) {
output += "\n            <p class=\"comet-long-form-text comet-long-form-text--bold\">\n                ";
output += runtime.suppressValue((lineno = 135, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["PLEASE NOTE: The file named Error-Report.pdf (included with your download) contains additional information on resolving any QR issue errors."])), env.opts.autoescape);
output += "\n            </p>\n        ";
;
}
output += "\n    </div>\n    <div class=\"download-complete__footer\">\n        <div class=\"comet-modal__button-row assign-form__buttons bulk-qr-return-to-admin\">\n            <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nextURL"), env.opts.autoescape);
output += "\" class=\"comet-button comet-button--primary comet-modal__button assign-form__button bulk-qr-continue\" type=\"button\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "isAdmin")) {
output += "\n                    ";
output += runtime.suppressValue((lineno = 143, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Return to My Admin"])), env.opts.autoescape);
output += "\n                ";
;
}
else {
output += "\n                    ";
output += runtime.suppressValue((lineno = 145, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Return to Classrooms"])), env.opts.autoescape);
output += "\n                ";
;
}
output += "\n            </a>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/classrooms/templates/includes/components/_bulk_qr_distribute", function(){});

